module.exports = __webpack_public_path__ + "static/img/ISO14001_Renwu_2.7f8743bf.jpg";